import React, { Component } from 'react';
import { Button } from 'reactstrap';
import moment from 'moment';

export class RepPortalTableSmall extends Component {
  static displayName = RepPortalTableSmall.name;

  render() {
    const { workOrders, onAuthorize } = this.props;

    if (!workOrders) return null;

    return (
      <div
        style={{
          padding: 0,
          margin: 0,
          height: 'calc(100dvh - 120px)',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          background: '#f5f5f5',
          paddingBottom: 24,
        }}
      >
        {workOrders.map((wo) => (
          <div
            key={wo.jobId}
            style={{
              background: '#fff',
              borderRadius: 8,
              boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
              margin: '10px 0',
              padding: 12,
              fontSize: 16,
              lineHeight: 1.4,
              maxWidth: 480,
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <div style={{ fontWeight: 600, color: '#d35400', marginBottom: 6 }}>
              Job #{wo.jobNum}
            </div>
            <div style={{ marginBottom: 4 }}>
              <b>Date:</b>{' '}
              {wo.jobDateTime ? moment(wo.jobDateTime).format('MM/DD/YYYY h:mm A') : ''}
            </div>
            <div style={{ marginBottom: 4 }}>
              <b>Claimant:</b> {wo.clmLastName}, {wo.clmFirstName}
            </div>
            {wo.clmClaimNumber && (
              <div style={{ marginBottom: 4 }}>
                <b>Claim #:</b> {wo.clmClaimNumber}
              </div>
            )}
            {wo.clmLanguage && (
              <div style={{ marginBottom: 4 }}>
                <b>Language:</b> {wo.clmLanguage}
              </div>
            )}
            {(wo.intLastName || wo.intFirstName) && (
              <div style={{ marginBottom: 4 }}>
                <b>Interpreter:</b> {wo.intLastName}, {wo.intFirstName}
              </div>
            )}
            {wo.aptCity && (
              <div style={{ marginBottom: 4 }}>
                <b>Location:</b> {wo.aptCity}
              </div>
            )}
            {(wo.repLastName || wo.repFirstName) && (
              <div style={{ marginBottom: 4 }}>
                <b>Rep:</b> {wo.repLastName}, {wo.repFirstName}
              </div>
            )}
            {!wo.repAuthorizedFlg && onAuthorize && (
              <Button
                color="success"
                size="sm"
                style={{ marginTop: 8, minHeight: 44, padding: '8px 16px' }}
                onClick={() => onAuthorize(wo.jobId)}
              >
                Authorize
              </Button>
            )}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 6 }}>
              {wo.invoicedFlg && (
                <span style={{ background: '#d4edda', color: '#155724', borderRadius: 4, padding: '2px 8px', fontSize: 13 }}>
                  Invoiced
                </span>
              )}
              {wo.repAuthorizedFlg && (
                <span style={{ background: '#d1ecf1', color: '#0c5460', borderRadius: 4, padding: '2px 8px', fontSize: 13 }}>
                  Authorized
                </span>
              )}
              {wo.failedFlg && (
                <span style={{ background: '#f8d7da', color: '#721c24', borderRadius: 4, padding: '2px 8px', fontSize: 13 }}>
                  Failed
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }
}
